import ReminderCard from './ReminderCard';
export default ReminderCard;
